module.exports = __webpack_public_path__ + "img/9788984077621.be1e6158.jpg";